import React, { useState, useCallback, useEffect } from 'react';
import pizzCategoryImg1 from '@iso/assets/images/localeats/pizzaCategory/1.png';
import pizzCategoryImg2 from '@iso/assets/images/localeats/pizzaCategory/2.png';
import pizzCategoryImg3 from '@iso/assets/images/localeats/pizzaCategory/3.png';
import pizzCategoryImg4 from '@iso/assets/images/localeats/pizzaCategory/4.png';
import pizzCategoryImg5 from '@iso/assets/images/localeats/pizzaCategory/5.png';
import pizzCategoryImg6 from '@iso/assets/images/localeats/pizzaCategory/6.png';
import pizzCategoryImg7 from '@iso/assets/images/localeats/pizzaCategory/7.png';
import pizzCategoryImg8 from '@iso/assets/images/localeats/pizzaCategory/8.png';
import pizzCategoryImg9 from '@iso/assets/images/localeats/pizzaCategory/9.png';
import pizzCategoryImg10 from '@iso/assets/images/localeats/pizzaCategory/10.png';
import pizzCategoryImg11 from '@iso/assets/images/localeats/pizzaCategory/11.png';
import pizzCategoryImg12 from '@iso/assets/images/localeats/pizzaCategory/12.png';
import pizzCategoryImg13 from '@iso/assets/images/localeats/pizzaCategory/13.png';
import pizzCategoryImg14 from '@iso/assets/images/localeats/pizzaCategory/14.png';

import IntlMessages from '@iso/components/utility/intlMessages';

let cityArr = [
  {
    id: 149,
    img: pizzCategoryImg1,
    key: 'Los Angeles',
    name: <IntlMessages id="filter.los-angeles" />,
  },
  {
    id: 154,
    img: pizzCategoryImg2,
    key: 'Hollywood',
    name: <IntlMessages id="filter.hollywood" />,
  },
  {
    id: 147,
    img: pizzCategoryImg6,
    key: 'San Francisco',
    name: <IntlMessages id="filter.san-francisco" />,
  },
  {
    id: 148,
    img: pizzCategoryImg7,
    key: 'San Diego',
    name: <IntlMessages id="filter.san-diego" />,
  },
  {
    id: 150,
    img: pizzCategoryImg8,
    key: 'Orange County',
    name: <IntlMessages id="filter.orange-county" />,
  },
  {
    id: 151,
    img: pizzCategoryImg9,
    key: 'Palo Alto',
    name: <IntlMessages id="filter.palo-alto" />,
  },
  {
    id: 152,
    img: pizzCategoryImg10,
    key: 'San Mateo',
    name: <IntlMessages id="filter.san-mateo" />,
  },
  {
    id: 153,
    img: pizzCategoryImg11,
    key: 'Mountain view',
    name: <IntlMessages id="filter.mountain-view" />,
  },
  {
    id: 157,
    img: pizzCategoryImg12,
    key: 'Syracuse',
    name: <IntlMessages id="filter.syracuse" />,
  },
  {
    id: 158,
    img: pizzCategoryImg13,
    key: 'Buffalo',
    name: <IntlMessages id="filter.buffalo" />,
  },
  {
    id: 159,
    img: pizzCategoryImg14,
    key: 'Silicon Valley',
    name: <IntlMessages id="filter.silicon-valley" />,
  },
];

export default cityArr;
